import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { CancelIcon, ValidateIcon } from 'components/Icons';

const useStyles = makeStyles(theme => ({
  buttonLine: {
    display: 'flex',
    marginTop: '25px',
    marginBottom: '15px',
    justifyContent: 'center',
  },
  button: {
    display: 'flex',
    alignItems: 'end',
    padding: '10px',
    margin: '0 10px',
  },
  icon: {
    color: theme.palette.text.primary,
    fontSize: 'medium',
    fontWeight: 600,
    marginLeft: '6px',
  },
}));

interface Props {
  title: string;
  cancelText: string;
  validationText: string;
  cancelAction: any;
  validateAction: any;
}

const ConfirmationPopInContent: React.FC<Props> = ({
  title,
  cancelText,
  validationText,
  cancelAction,
  validateAction,
}) => {
  const classes = useStyles();

  return (
    <div>
      <Typography variant="h2">{title}</Typography>
      <div className={classes.buttonLine}>
        <Button variant="outlined" className={classes.button} onClick={cancelAction}>
          {cancelText}
          <CancelIcon className={classes.icon} />
        </Button>
        <Button variant="outlined" className={classes.button} onClick={validateAction}>
          {validationText}
          <ValidateIcon className={classes.icon} />
        </Button>
      </div>
    </div>
  );
};

export default ConfirmationPopInContent;
